import type { ApolloClient } from '@apollo/client';
import { useFragment } from '@apollo/client';

import type {
  AiGeneratedImageQuery,
  AiGeneratedImageQueryVariables,
  AiGeneratedImageRegionsFragment,
} from 'src/shared/graphql/generated';
import {
  AiGeneratedImageDocument,
  AiGeneratedImageRegionsFragmentDoc,
} from 'src/shared/graphql/generated';

export const getCachedAiGeneratedImage = (
  client: ApolloClient<any>,
  id: number,
) =>
  client.readQuery<AiGeneratedImageQuery, AiGeneratedImageQueryVariables>({
    query: AiGeneratedImageDocument,
    variables: { id: `${id}` },
  });

export const useCachedAiGeneratedImageRegions = (id: number) =>
  useFragment<AiGeneratedImageRegionsFragment | undefined>({
    fragment: AiGeneratedImageRegionsFragmentDoc,
    fragmentName: 'AiGeneratedImageRegions',
    from: {
      __typename: 'AiGeneratedImage',
      id,
    },
  });
